import React from 'react';
import Table from '../common/Table';
import Badge from '../common/Badge';
import { formatCurrency, formatDate } from '../../utils/helpers';
import { getStockStatus } from '../../utils/productHelpers';

const ProductManagementTable = ({ products, onProductClick, onDelete }) => {
  const columns = [
    {
      header: 'Product',
      accessor: 'name',
      render: (product) => (
        <div style={{ display: 'flex', alignItems: 'center', gap: '12px' }}>
          <img 
            src={product.images?.[0] || '/placeholder.png'} 
            alt={product.name}
            style={{ width: '50px', height: '50px', objectFit: 'cover', borderRadius: '4px' }}
          />
          <div>
            <div style={{ fontWeight: 600 }}>{product.name}</div>
            <div style={{ fontSize: '12px', color: '#6b7280' }}>{product.sku || 'No SKU'}</div>
          </div>
        </div>
      ),
    },
    {
      header: 'Category',
      accessor: 'category',
      render: (product) => product.category?.name || 'N/A',
    },
    {
      header: 'Seller',
      accessor: 'seller',
      render: (product) => product.seller?.store_name || 'N/A',
    },
    {
      header: 'Price',
      accessor: 'price',
      render: (product) => formatCurrency(product.price),
    },
    {
      header: 'Stock',
      accessor: 'quantity',
      render: (product) => {
        const status = getStockStatus(product);
        return <Badge variant={status.color}>{status.label}</Badge>;
      },
    },
    {
      header: 'Status',
      accessor: 'is_active',
      render: (product) => (
        <Badge variant={product.is_active ? 'success' : 'error'}>
          {product.is_active ? 'Active' : 'Inactive'}
        </Badge>
      ),
    },
    {
      header: 'Created',
      accessor: 'created_at',
      render: (product) => formatDate(product.created_at),
    },
  ];

  return <Table columns={columns} data={products} onRowClick={onProductClick} />;
};

export default ProductManagementTable;